import { render } from "./organization.vue?vue&type=template&id=4d0daae2"
import script from "./organization.vue?vue&type=script&lang=js"
export * from "./organization.vue?vue&type=script&lang=js"

import "./organization.vue?vue&type=style&index=0&id=4d0daae2&lang=sass"

import exportComponent from "C:\\Users\\67026\\Desktop\\front1.0\\front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
